<template>
  <div>
    <transition
      name="animate__fadeIn"
      enter-active-class="animate__animated animate__fadeIn"
      leave-active-class="animate__animated animate__fadeOut"
      appear
    >
      <b-row>
        <b-col cols="7" class="d-none d-lg-block mt-10">
          <b-container>
            <img
              src="@/assets/images/background1.png"
              width="100%"
              v-if="getVersion === 'v1'"
            />
            <img
              src="@/assets/images/mainPaymentImage.png"
              width="100%"
              v-if="getVersion === 'v2'"
            />
          </b-container>
          <b-col cols="12" v-if="getVersion === 'v1'">
            <b-container class="mt-10">
              <h1 class="text-center font-size-xl pb-3">
                {{ $translate("register") }}
              </h1>
              <p class="font-size-large text-center dodger-blue-text">
                {{ $translate("onlyEnterCardPhoneNumberAndGatewayType") }}
              </p>
            </b-container>
          </b-col>
        </b-col>
        <b-col cols="12" lg="5">
          <shetab-stepper v-if="getVersion === 'v1'"></shetab-stepper>
          <b-row>
            <b-col
              cols="12"
              class="text-center dodger-blue-text pt-2 font-size-medium-small"
              v-if="getVersion === 'v1'"
            >
              {{ $translate("receiverName") }}: {{ $translate("caspianPay") }}
            </b-col>
            <b-col
              cols="12"
              class="text-center black-text pt2 font-size-medium-small font-weight-bold pb-4"
              v-if="getVersion === 'v2'"
            >
              {{ $translate("receiverName") }}: {{ $translate("clubBaz") }}
            </b-col>
          </b-row>
          <b-container
            class="background-secondary border-radius-10px border-light-gray-1px mt-1 p-0 mb-3"
          >
            <b-col
              cols="12"
              v-if="getPaymentSuccess"
              class="background-green text-white text-center"
            >
              <b-col cols="12">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="50"
                  height="75"
                  fill="currentColor"
                  class="bi bi-check-lg"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M13.485 1.431a1.473 1.473 0 0 1 2.104 2.062l-7.84 9.801a1.473 1.473 0 0 1-2.12.04L.431 8.138a1.473 1.473 0 0 1 2.084-2.083l4.111 4.112 6.82-8.69a.486.486 0 0 1 .04-.045z"
                  />
                </svg>
              </b-col>
              <b-col cols="12" class="pb-1"
                ><span class="font-size-large">{{
                  $translate("paymentSuccessful")
                }}</span></b-col
              >
              <b-col cols="12" class="pb-1"
                ><span class="font-size-medium-small"
                  >{{ $translate("bank") }} {{ bankGateAway }}</span
                >
              </b-col>
              <b-col cols="12" class="pb-1"
                ><span class="font-size-large break-word">
                  {{ paymentId | persianDigit }}</span
                ></b-col
              >
            </b-col>
            <b-col cols="12" v-if="!getPaymentSuccess">
              <b-col
                cols="12"
                class="background-indian-red text-white text-center"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="50"
                  height="75"
                  fill="currentColor"
                  class="bi bi-x-lg"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M1.293 1.293a1 1 0 0 1 1.414 0L8 6.586l5.293-5.293a1 1 0 1 1 1.414 1.414L9.414 8l5.293 5.293a1 1 0 0 1-1.414 1.414L8 9.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L6.586 8 1.293 2.707a1 1 0 0 1 0-1.414z"
                  />
                </svg>
                <b-col cols="12" class="pb-1"
                  ><span class="font-size-large">{{
                    $translate("paymentFailed")
                  }}</span>
                </b-col>
                <b-col cols="12" class="pb-1"
                  ><span class="font-size-medium-small"
                    >{{ $translate("bank") }} {{ bankGateAway }}</span
                  ></b-col
                >
                <b-col cols="12" class="pb-1"
                  ><span class="font-size-large break-word">
                    {{ paymentId | persianDigit }}</span
                  ></b-col
                >
              </b-col>
            </b-col>
            <b-container>
              <b-row>
                <b-col
                  cols="12"
                  class="text-center pt-2"
                  v-if="getPaymentSuccess"
                  ><span class="font-size-medium-small">{{
                    getRefNumber | persianDigit
                  }}</span></b-col
                >
              </b-row>

              <b-row
                class="font-size-medium-small pb-3"
                v-if="getPaymentSuccess"
              >
                <b-col cols="4" class="info-grey-text"
                  >{{ $translate("dateAndTime") }}:</b-col
                >
                <b-col
                  cols="8"
                  class="text-start midnight-blue-text"
                  :class="{ 'black-text': getVersion === 'v2' }"
                  >{{ timestamp | persianDigit }}
                </b-col>
              </b-row>
              <b-row
                class="font-size-medium-small pb-3"
                v-if="getPaymentSuccess"
              >
                <b-col
                  cols="4"
                  class="info-grey-text"
                  :class="{ 'black-text': getVersion === 'v2' }"
                  >{{ $translate("trackingNumber") }}:
                </b-col>
                <b-col
                  cols="8"
                  class="text-start midnight-blue-text"
                  :class="{ 'black-text': getVersion === 'v2' }"
                  >{{ getRefNumber | persianDigit }}
                </b-col>
              </b-row>
              <b-row
                class="font-size-medium-small pb-3"
                v-if="getPaymentSuccess"
              >
                <b-col
                  cols="4"
                  class="info-grey-text"
                  :class="{ 'black-text': getVersion === 'v2' }"
                  >{{ $translate("transactionAmount") }}:
                </b-col>
                <b-col cols="8" class="text-start green-text font-weight-bold">
                  {{ getShetabSelectedPayingAmount | commaSep | persianDigit }}
                  {{ $translate("toman") }}
                </b-col>
              </b-row>
              <b-row
                class="font-size-medium-small pb-3"
                v-if="!getPaymentSuccess"
              >
                <b-col
                  cols="4"
                  class="info-grey-text"
                  :class="{ 'black-text': getVersion === 'v2' }"
                  >{{ $translate("transactionAmount") }}:
                </b-col>
                <b-col
                  cols="8"
                  class="text-start indian-red-text font-weight-bold"
                >
                  {{ getShetabSelectedPayingAmount | commaSep | persianDigit }}
                  {{ $translate("toman") }}
                </b-col>
              </b-row>
              <b-col
                cols="12"
                class="text-center pb-5"
                v-if="getPaymentSuccess"
                :class="{ paddingThirtyPercent: getVersion === 'v2' }"
              >
                <span
                  class="font-weight-bold font-size-xl midnight-blue-text"
                  :class="{ 'black-text': getVersion === 'v2' }"
                >
                  {{ $translate("yourTransactionSuccessfullyDone") }}
                </span>
              </b-col>
              <b-col
                cols="12"
                class="text-center pb-5"
                v-if="!getPaymentSuccess"
                :class="{ paddingThirtyPercent: getVersion === 'v2' }"
              >
                <span
                  class="font-weight-bold font-size-xl midnight-blue-text"
                  :class="{ 'black-text': getVersion === 'v2' }"
                >
                  {{ $translate("yourTransactionFailed") }}!
                  <br />
                  {{
                    $translate(
                      "withPressingTheTryAgainButtonYouCanTryAnotherSwitch"
                    )
                  }}
                </span>
              </b-col>
              <b-col cols="12" class="d-flex justify-content-center pb-3">
                <!--                <b-col-->
                <!--                  cols="6"-->
                <!--                  v-if="!getPaymentSuccess && getVersion === 'v1'"-->
                <!--                >-->
                <!--                  <button-->
                <!--                    class="cancel-button"-->
                <!--                    @click="cancel"-->
                <!--                    :class="{ newVersionButtonClass: getVersion === 'v2' }"-->
                <!--                  >-->
                <!--                    انصراف-->
                <!--                  </button>-->
                <!--                </b-col>-->
                <b-col
                  cols="6"
                  v-if="!getPaymentSuccess"
                  :class="{ 'col-12': getVersion === 'v2' }"
                >
                  <button
                    class="try-again-button"
                    @click="tryAgain"
                    :class="{
                      'newVersionButtonClass background-light-green':
                        getVersion === 'v2',
                    }"
                  >
                    {{ $translate("tryAgain") }}
                  </button>
                </b-col>
                <b-col class="autoCallBackUrlInfo" v-if="getPaymentSuccess">
                  {{ $translate("transferringToTheReceiverPage") }}
                  <div
                    class="spinner-border text-success"
                    style="width: 1rem; height: 1rem"
                  ></div>
                </b-col>
                <button
                  class="confirmButton"
                  v-if="getPaymentSuccess"
                  @click="goToCallBackUrl"
                  :class="{
                    'newVersionButtonClass background-light-green':
                      getVersion === 'v2',
                  }"
                >
                  {{ $translate("accept") }}
                </button>
              </b-col>
            </b-container>
          </b-container>
        </b-col>
      </b-row>
    </transition>
  </div>
</template>

<script>
import shetabStepper from "@/components/ShetabStepper";
import { shetabFinalMixin } from "@/mixins/ShetabMixins/ShetabFinalMixin";

export default {
  name: "shetabFinal",
  components: {
    shetabStepper: shetabStepper,
  },

  mixins: [shetabFinalMixin],
};
</script>

<style scoped>
.confirmButton {
  width: 75%;
  height: 35px;
  border: none !important;
  border-radius: 10px;
  background-color: var(--dodger-blue);
  color: white;
}

.try-again-button {
  width: 100%;
  height: 35px;
  border: none !important;
  border-radius: 10px;
  background-color: var(--dodger-blue);
  color: white;
}

.cancel-button {
  width: 100%;
  height: 35px;
  margin-left: 10px;
  border: none !important;
  border-radius: 10px;
  background-color: var(--indian-red);
  color: white;
}

.newVersionButtonClass {
  border-radius: 5px !important;
}

.paddingThirtyPercent {
  padding-bottom: 30% !important;
}
</style>
